import { render } from "./JoinApply.vue?vue&type=template&id=5195474c&scoped=true"
import script from "./JoinApply.vue?vue&type=script&lang=js"
export * from "./JoinApply.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5195474c"]])

export default __exports__